import { useAuth0 } from "@auth0/auth0-react";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import SearchDownShift from "components/downmshift/DownShift";
import { useFormik } from "formik";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import NotAuthorized from "../../../../components/NotAuthorized";
import SettingHeader from "../../SettingHeader/settingHEader";
import ComponentHeading from "../../componentHeading/ComponentHeading";
import LeftMenu from "../../leftMenu/LeftMenu";
const BankAccountsView = ({ heading }) => {
  const localStorageData = localStorage.getItem("organization")
  ? JSON.parse(localStorage.getItem("organization"))
  : null;
  const { getAccessTokenSilently } = useAuth0();
  const [typeID, setTypeID] = useState("chase");
  const [type, setType] = useState("");
  const [disable, setDisable] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [disableAddNew, setDaisableAddNew] = useState(false);
  const [edit, setEdit] = useState(false);
  const [addPath, setAddPath] = useState();
  const [bankAccountList, setBankAccountList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [bankAccountData, setBankAccountData] = useState();
  const [fieldsOnDelete, setFieldsOnDelete] = useState(false);
  const [bankAccountId, setBankAccountId] = useState("");
  const [IsSettingsActive, setIsSettingsActive] = useState(true);
  const formik = useFormik({
    enableReinitialize: true,

    initialValues:
      addNew === true
        ? {
            default_bank_account: false,
            bank_account_name: "",
            quickBooks_id: "",
            quickBooks_name: "",
          }
        : {
            bank_account_name:
              bankAccountData?.title ?? bankAccountList[0]?.title ?? "",
            quickBooks_id:
              bankAccountData?.quickBooks_id ??
              bankAccountList[0]?.quickBooks_id ??
              "",
            quickBooks_name:
              bankAccountData?.quickBooks_name ??
              bankAccountList[0]?.quickBooks_name ??
              "",

            default_bank_account:
              bankAccountData?.is_default ??
              bankAccountList[0]?.is_default ??
              false,
          },
  });
  const initialSatge = () => {
    formik.setFieldValue("bank_account_name", bankAccountList[0]?.title);
    formik.setFieldValue(
      "default_bank_account",
      bankAccountList[0]?.is_default
    );
  };

  const isProgramSage = localStorageData?.quickBooks_information?.program === "sage";
  const isProgramOnline = localStorageData?.quickBooks_information?.program === "online";
  const isProgramDisable = localStorageData?.quickBooks_information?.program === "disable";


  const { pathname } = useLocation();
  const { push } = useHistory();
  useEffect(() => {
    if (pathname.includes("view")) {
      setEdit(false);
      setDaisableAddNew(false);
      setDisable(false);
      setAddNew(false);
    }
  }, [pathname]);
  useEffect(() => {
    if (searchValue === "") {
      fetchBankAccountList();
    } else {
      setSearchValue(searchValue);
    }
  }, [searchValue]);
  const option2 = bankAccountList?.map((item, index) => ({
    id: item?._id,
    name: item?.title,
  }));

  // Get Bank Account List
  const fetchBankAccountList = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getBankAccountList(token).then((res) => {
      setBankAccountList(res?.result);
      setType(res?.result[0]?.title);
    });
  };

  // Get Bank Account List By Id
  const getBankAccountListById = async (type, id) => {
    setFieldsOnDelete(false);
    setType(type);
    setBankAccountId(id);
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getBankAccountsById(id, token).then((res) => {
      setBankAccountData(res?.result);
    });
  };

  // update Bank Account by ID
  const updateBankAccount = async () => {
    if(!isProgramDisable && !formik.values?.quickBooks_name) {
      return toastr.info('Validation', "Please fill all the mandatory fields");
    }
    if((isProgramOnline || isProgramSage) && !formik.values?.quickBooks_id) {
      return toastr.info('Validation', "Please fill all the mandatory fields");
    }
    if (formik.values?.bank_account_name == "") {
      toastr.info('Validation', "Please enter a valid account name");
    } else {
      setFieldsOnDelete(false);
      const token = await getAccessTokenSilently();
      await FinanceSettingService.updateBankAccountById(
        bankAccountId || bankAccountList[0]?._id,
        {
          title: formik.values?.bank_account_name,
          is_default: formik.values?.default_bank_account ?? false,
          quickBooks_name: (!isProgramDisable) ? formik.values?.quickBooks_name : undefined,
          quickBooks_id: (isProgramOnline || isProgramSage) ? formik.values?.quickBooks_id : undefined,
        },
        token
      )
        .then(() => {
          toastr.success("Success", "Bank Account has been updated");
          formik.setFieldValue("default_bank_account", false);
          formik.setFieldValue("bank_account_name", "");
          formik.setFieldValue("quickBooks_id", "");
          formik.setFieldValue("quickBooks_name", "");
          push({
            pathname: "/financial-setting/bank-accounts/view",
          });
        })
        .catch((error) => {
          console.log(error);
          toastr.error(
            "Update Error",
            error?.data?.message ?? "Some fields are missing"
          );
        });
      // fetchBankAccountList();
      // initialSatge();
      const currentId = bankAccountId || bankAccountList[0]?._id;

await fetchBankAccountList();

if (currentId) {
  const updatedItem = bankAccountList?.find(
    (item) => item._id === currentId
  );

  if (updatedItem) {
    setType(updatedItem.title);
    setBankAccountId(updatedItem._id);
    await getBankAccountListById(updatedItem.title, updatedItem._id);
  }
}
    }
  };

  // Disable  Account Billing type
  const deletBankAccountById = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.deleteBankAccountById(
      bankAccountId || bankAccountList[0]?._id,
      token
    ).then((res) => {
      if (res) {
        setFieldsOnDelete(true);
      }
    });
    fetchBankAccountList();
    initialSatge();
  };

  // Create A New Account Billing Type
  const createNewBankAccount = async () => {
    if(!isProgramDisable && !formik.values?.quickBooks_name) {
      return toastr.info('Validation', "Please fill all the mandatory fields");
    }
    if((isProgramOnline || isProgramSage) && !formik.values?.quickBooks_id) {
      return toastr.info('Validation', "Please fill all the mandatory fields");
    }
    if (formik.values?.bank_account_name == "") {
      toastr.info('Validation', "Please enter a valid account name");
    } else {
      const token = await getAccessTokenSilently();
      await FinanceSettingService.createNewBankAccount(
        {
          title: formik.values?.bank_account_name,
          is_default: formik.values?.default_bank_account ?? false,
          quickBooks_name: formik.values?.quickBooks_name,
          quickBooks_id: formik.values?.quickBooks_id,
        },
        token
      )
        .then(() => {
          toastr.success("Success", "New Bank Account has been created");
          setFieldsOnDelete(true);
          push({
            pathname: "/financial-setting/bank-accounts/view",
          });
        })
        .catch((e) => {
          console.log(e, "error");
          toastr.error(e?.data?.message ?? "Error");
        });
      fetchBankAccountList();
    }
  };

  const debounceSearch = useCallback(
    debounce(async () => {
      if (searchValue) {
        const token = await getAccessTokenSilently();
        await FinanceSettingService.searchBankAccounts(searchValue, token).then(
          (res) => {
            setBankAccountList(res.result);
          }
        );
      }
    }, 1000),
    [searchValue]
  );

  const formatResult = (item) => {
    return (
      <div className="result-wrapper">
        <span className="result-span">name: {item.name}</span>
      </div>
    );
  };
  useEffect(() => {
    debounceSearch();
    return () => {
      debounceSearch.cancel();
    };
  }, [debounceSearch, searchValue]);
  useEffect(() => {
    fetchBankAccountList();
  }, []);
  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "financial setting") {
        return setIsSettingsActive(item?.active);
      }
    });
  }, []);
  return IsSettingsActive == false ? (
    <NotAuthorized title={"Reports"} />
  ) : (
    <div className="w-100">
      <SettingHeader
        heading={heading}
        edit={edit}
        addNew={addNew}
        path={"/financial-setting/bank-accounts/view"}
        setAddNew={setAddNew}
        parentHeading={"Financial"}
        alertOnEdit={edit}
      />
      <div className="main-setting__wrapper">

      <div className="col-md-4 mb-5 pl-7 pr-7">
        <SearchDownShift
          items={option2}
          name={searchValue}
          setName={setSearchValue}
          placeHolder="Search"
          autoFocus
        />
      </div>
      <div className="setting-main">
        <div className="left-menu-div">
          <LeftMenu
            getTypeId={getBankAccountListById}
            types={bankAccountList}
            btnText={"New Bank Account"}
            disable={disable}
            setAddNew={setAddNew}
            setDisable={setDisable}
            disableAddNew={disableAddNew}
            setDaisableAddNew={setDaisableAddNew}
            addPath={addPath}
          />
        </div>
        <div className="settings-details">
          <ComponentHeading
            type={formik.values?.bank_account_name || type}
            heading={heading}
            addNew={addNew}
            disable={disable}
            setDisable={setDisable}
            setDaisableAddNew={setDaisableAddNew}
            edit={edit}
            setEdit={setEdit}
            setAddPath={setAddPath}
            formik={formik}
            updateFunc={updateBankAccount}
            deleteFunc={deletBankAccountById}
            createFunc={createNewBankAccount}
            setAddNew={setAddNew}
            disableAddNew={disableAddNew}
          />
        </div>
      </div>
      </div>
    </div>
  );
};

export default BankAccountsView;
